/** Uno - Planner browser cache async storage prefix */ export const PlannerAsyncStoragePrefix = "Planner";
/** Evo - Planner browser cache async storage prefix */ export const PlannerV2AsyncStoragePrefix = "PlannerV2";
/**
 * Evo - Planner browser cache async storage schema version
 */ export const PlannerV2AsyncStorageSchemaVersionV1 = 1;
/** Uno - Planner browser cache async storage schema version V1
 * This version is used for shipping Mru store persistence - mru items and collection status
 */ export const PlannerAsyncStorageSchemaVersionV1 = 1;
/** Uno - Planner browser cache async storage schema version V2
 * This version will be used for shipping persistence for required stores for myDay, myTasks, BasicPlan and myPlans pages
 */ export const PlannerAsyncStorageSchemaVersionV2 = 2;
export var PlannerPersistedObjectStoreKeys;
(function(PlannerPersistedObjectStoreKeys) {
    PlannerPersistedObjectStoreKeys["Mru"] = "server_doc_id";
    PlannerPersistedObjectStoreKeys["Plans"] = "id";
    PlannerPersistedObjectStoreKeys["Buckets"] = "id";
    PlannerPersistedObjectStoreKeys["Tasks"] = "id";
    PlannerPersistedObjectStoreKeys["Status"] = "key";
    PlannerPersistedObjectStoreKeys["Goals"] = "id";
    PlannerPersistedObjectStoreKeys["ViewConfig"] = "viewId";
})(PlannerPersistedObjectStoreKeys || (PlannerPersistedObjectStoreKeys = {}));
export var PlannerPersistedObjectStoreIndexNames;
(function(PlannerPersistedObjectStoreIndexNames) {
    PlannerPersistedObjectStoreIndexNames["MruPinnedIndex"] = "isPinnedString";
    PlannerPersistedObjectStoreIndexNames["BucketsPlanIndex"] = "planId";
    PlannerPersistedObjectStoreIndexNames["TasksPlanIndex"] = "planId";
    PlannerPersistedObjectStoreIndexNames["TasksMyDayDateIndex"] = "myDayDate";
    PlannerPersistedObjectStoreIndexNames["TasksAssigneeIdentityIdIndex"] = "assigneeIdentityIds";
    PlannerPersistedObjectStoreIndexNames["GoalsPlanIndex"] = "planId";
})(PlannerPersistedObjectStoreIndexNames || (PlannerPersistedObjectStoreIndexNames = {}));
export var PersistedObjectStoreKeys;
(function(PersistedObjectStoreKeys) {
    PersistedObjectStoreKeys["Mru"] = "server_doc_id";
    PersistedObjectStoreKeys["Plans"] = "id";
    PersistedObjectStoreKeys["Buckets"] = "id";
    PersistedObjectStoreKeys["Tasks"] = "id";
    PersistedObjectStoreKeys["Status"] = "key";
})(PersistedObjectStoreKeys || (PersistedObjectStoreKeys = {}));
export var PersistedObjectStoreIndexNames;
(function(PersistedObjectStoreIndexNames) {
    PersistedObjectStoreIndexNames["MruPinnedIndex"] = "isPinnedString";
    PersistedObjectStoreIndexNames["BucketsPlanIndex"] = "planId";
    PersistedObjectStoreIndexNames["TasksPlanIndex"] = "planId";
    PersistedObjectStoreIndexNames["TasksMyDayDateIndex"] = "myDayDate";
    PersistedObjectStoreIndexNames["TasksAssignmentsIndex"] = "assigneeIds";
})(PersistedObjectStoreIndexNames || (PersistedObjectStoreIndexNames = {}));
